export default "__VITE_ASSET__DsOEprg3__"